module.exports = __webpack_public_path__ + "img/placeholder.b3ff9292.jpg";